<script setup lang="ts">
// index
import View from '~/pages-components/announcement/index.vue'
</script>

<template>
  <ClientOnly>
    <View />
    <template #fallback>
      <div class="flex-center h400px">
        <i class="i-svg-spinners:180-ring-with-bg block text-text-blue text-30px" />
      </div>
    </template>
  </ClientOnly>
</template>

<style scoped lang="scss"></style>
